export default "__VITE_ASSET__Cf9_DeJy__"